var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import LoginButton from "./LoginButton.vue";
import PasswordLogin from "./PasswordLogin.vue";
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Login.prototype.shouldShow = function (provider) {
        return (this.include.length === 0 || this.include.indexOf(provider) !== -1)
            && (this.exclude.length === 0 || this.exclude.indexOf(provider) === -1);
    };
    __decorate([
        Prop({ type: String, required: true })
    ], Login.prototype, "externalFormAction", void 0);
    __decorate([
        Prop({ type: String })
    ], Login.prototype, "registerUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], Login.prototype, "formAction", void 0);
    __decorate([
        Prop({ type: String })
    ], Login.prototype, "resetPasswordUrl", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Login.prototype, "small", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Login.prototype, "group", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Login.prototype, "fluid", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Login.prototype, "inline", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Login.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Login.prototype, "include", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Login.prototype, "exclude", void 0);
    __decorate([
        Prop({ type: String, default: "Log in using your {0} account" })
    ], Login.prototype, "captionFormat", void 0);
    __decorate([
        Prop({ type: String, default: "{0}" })
    ], Login.prototype, "textFormat", void 0);
    Login = __decorate([
        Component({
            name: "LoginButtonList",
            components: {
                LoginButton: LoginButton,
                PasswordLogin: PasswordLogin
            }
        })
    ], Login);
    return Login;
}(Vue));
export default Login;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/LoginButtonList.vue
// module id = 666
// module chunks = 24